const asyncActionType = type => ({
  pending: `${type}_PENDING`,
  success: `${type}_SUCCESS`,
  error: `${type}_ERROR`
});

export const ADD_PLANNED_DATA = asyncActionType('aerosimple/settings/ADD_PROPERTY');
export const FETCH_PLAN_SCHEDULE = asyncActionType('aerosimple/settings/FETCH_PLAN_SCHEDULE');
export const FETCH_PLAN_LIST = asyncActionType('aerosimple/settings/FETCH_PLAN_LIST');
export const FETCH_DETAIL = asyncActionType('aerosimple/settings/FETCH_DETAIL');
export const UPDATE_DATA = asyncActionType('aerosimple/settings/UPDATE_DATA');
export const GET_TEMPLATE = asyncActionType('aerosimple/settings/GET_TEMPLATE');
export const FETCH_GATES_LIST = asyncActionType('aerosimple/settings/FETCH_GATES_LIST');
export const GET_AIRPORTS_DATA = asyncActionType('aerosimple/settings/GET_AIRPORTS_DATA');
export const GET_REQUEST_LOG = asyncActionType('aerosimple/settings/GET_REQUEST_LOG');
export const FETCH_REQUEST_LOGS = asyncActionType('aerosimple/settings/FETCH_REQUEST_LOGS');
export const GATE_REQUEST_UPDATE = asyncActionType('aerosimple/settings/GATE_REQUEST_UPDATE');
export const FETCH_ALLOCATION_DATA = asyncActionType('aerosimple/settings/FETCH_ALLOCATION_DATA');
export const CLEAR_DATA = asyncActionType('aerosimple/settings/CLEAR_DATA');
